import { useMutation } from "react-query";
import axios from "axios";

export const useGenericGet = (token, onSuccess, onError) => {
  const fetchData = async ({ url, params }) => {
    const finalUrl = `${url}?${params}`;

    const response = await axios.get(finalUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });

    return response.data;
  };

  return useMutation(fetchData, {
    onSuccess,
    onError,
  });
};
